import { SVGProps } from "react"

const EditUserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    {...props}
  >
    <path
      d="M9 7.25C9.34472 7.25 9.68606 7.1821 10.0045 7.05018C10.323 6.91827 10.6124 6.72491 10.8562 6.48116C11.0999 6.2374 11.2933 5.94802 11.4252 5.62954C11.5571 5.31106 11.625 4.96972 11.625 4.625C11.625 4.28028 11.5571 3.93894 11.4252 3.62046C11.2933 3.30198 11.0999 3.0126 10.8562 2.76884C10.6124 2.52509 10.323 2.33173 10.0045 2.19982C9.68606 2.0679 9.34472 2 9 2C8.30381 2 7.63613 2.27656 7.14384 2.76884C6.65156 3.26113 6.375 3.92881 6.375 4.625C6.375 5.32119 6.65156 5.98887 7.14384 6.48116C7.63613 6.97344 8.30381 7.25 9 7.25V7.25Z"
      stroke="#2F69FE"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 15.875C1.5 12.5615 4.5225 9.875 8.25 9.875"
      stroke="#2F69FE"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.625 16.25L15.375 12.5L13.875 11L10.125 14.75V16.25H11.625Z"
      stroke="#2F69FE"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default EditUserIcon
